var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21.27 21.27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;stroke-width:0px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m10.63,0C4.76,0,0,4.76,0,10.63c0,5.87,4.76,10.63,10.63,10.63,5.87,0,10.63-4.76,10.63-10.63C21.27,4.76,16.51,0,10.63,0Zm6.95,17.58c-1.78,1.78-4.23,2.88-6.95,2.88-2.71,0-5.17-1.1-6.95-2.88-1.78-1.78-2.88-4.23-2.88-6.95,0-2.71,1.1-5.17,2.88-6.95C5.46,1.91,7.92.81,10.63.81c2.71,0,5.17,1.1,6.95,2.88,1.78,1.78,2.88,4.23,2.88,6.95,0,2.71-1.1,5.17-2.88,6.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m10.63,12.05l-1.23-1.08-3.51,3.01c.13.12.3.19.49.19h8.5c.19,0,.36-.07.49-.19l-3.51-3.01-1.23,1.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m15.37,7.28c-.13-.12-.3-.19-.49-.19H6.38c-.19,0-.36.07-.49.19l4.74,4.06,4.74-4.06Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "5.67 7.71 5.67 13.6 9.1 10.69 5.67 7.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "12.17 10.69 15.6 13.6 15.6 7.71 12.17 10.69"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.bb5d8c508a8d014405cc6cc5a7420662.svg";
export { ForwardRef as ReactComponent };